import React, { Component } from 'react';
import find from 'lodash/find';
import { browserHistory } from '../../browserHistory';
import {
  Dropdown,
  AnalyticsRating,
  AnalyticsOperatorMessages,
} from '../../components';

import styles from './PageAnalytics.scss';

export class PageAnalytics extends Component {

  REPORT_TYPES = [
    {
      id: 'rating',
      title: 'Рейтинг операторов',
    },
    {
      id: 'operator-messages',
      title: 'Коммуникация',
    }
  ];

  state = {
    reportType: null,
  };

  componentDidMount() {
    this.onReportTypeChange();
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (match.params.reportType !== prevProps.match.params.reportType) {
      this.onReportTypeChange();
    }
  }

  onReportTypeChange = () => {
    const { match } = this.props;
    const { reportType } = this.state;
    let newReportType = match.params.reportType?.toLowerCase?.();

    if (!find(this.REPORT_TYPES, { id: newReportType })) {
      newReportType = this.REPORT_TYPES[0].id;
      this.redirectToReportType(newReportType);
    }
    if (newReportType !== reportType) {
      this.setState({ reportType: newReportType });
    }
  };

  redirectToReportType = (reportType) => {
    browserHistory.push('/analytics/' + reportType);
  };

  renderReportMenu = () => {
    const { reportType } = this.state;
    const reportTypeOptions = this.REPORT_TYPES.map(({ title, id }) => ({ title, value: id }));
    const currentReportTitle = find(this.REPORT_TYPES, { id: reportType })?.title;

    return (
      <Dropdown
        buttonAppearance={true}
        items={reportTypeOptions}
        defaultValue={reportType}
        onChange={({value}) => this.redirectToReportType(value)}
        overrideClassNames={{
          container: styles.filterReportType,
          button: styles.filterReportTypeButton,
        }}>
        {currentReportTitle}
      </Dropdown>
    );
  };

  render() {
    const {reportType} = this.state;
    return (
      <div className={styles.container}>
        <h1 className={styles.header}>
          Центр аналитики
        </h1>
        {reportType === 'rating' && (
          <AnalyticsRating
            className={styles.content}
            renderReportMenu={this.renderReportMenu}/>
        )}
        {reportType === 'operator-messages' && (
          <AnalyticsOperatorMessages
            className={styles.content}
            renderReportMenu={this.renderReportMenu}/>
        )}
      </div>
    );
  }
}
